import type { ReactNode } from 'react';
import { useBootstrapAuth } from './use-bootstrap-auth';

export function AuthProvider({ children }: { children: ReactNode }) {
  useBootstrapAuth();
  return <>{children}</>;
}
